'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'locust';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e520';
var svgPathData = 'M576 272l0 48c0 49.8-37.9 90.7-86.3 95.5l20.7 41.3c4 7.9 .7 17.5-7.2 21.5s-17.5 .7-21.5-7.2l-27.6-55.2-136.2 0-32 55.9c-4.4 7.7-14.2 10.3-21.8 6s-10.3-14.2-6-21.8l22.9-40.1-32.2 0-12-.3c-11.4-.6-22.8-2.1-34-4.5l-45.9 62.3c-5.2 7.1-15.3 8.6-22.4 3.4s-8.6-15.3-3.4-22.4L170 401.7c-4.9-1.8-9.7-3.8-14.4-6l0 0-50.9-23.3-75.9 101.2c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4l71.7-95.6-1.9-.9-4.6-2.3C47.6 344.2 33.9 323 32.2 299.3l-.2-5.1c0-36.3 27.6-66.2 63-69.8l7.2-.4 73.8 0 67.2-89.6 2.7-2.8c2.9-2.4 6.7-3.7 10.6-3.6 5.2 .1 10 2.8 12.9 7.1l40.5 60.8 45.3-61.4 1.3-1.6c3.3-3.4 7.9-5.2 12.7-4.9 5.4 .4 10.3 3.5 12.9 8.3l47.8 87.7 50.2 0C503.9 224 525.7 232.7 542.5 247.2 530.3 144 442.5 64 336 64l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0c132.5 0 240 107.5 240 240zm-32 48l0-.3c-.1-35.2-28.7-63.7-64-63.7l-288 0-67.7 90.2 44.6 20.4C194 378.1 221.2 384 248.8 384l214.8 0c.2 0 .5 0 .7 0l15.7 0c35.3 0 63.9-28.6 64-63.9l0-.1zM393.4 224l-27.5-50.3-37.1 50.3 64.5 0zm-103.8-.7l-34.4-51.6-39.2 52.3 73.2 0 .5-.7zM94.5 332.6l57.5-76.6-49.8 0c-21.1 0-38.2 17.1-38.2 38.2 0 14.9 8.7 28.5 22.3 34.7l8.2 3.8zM472 296a24 24 0 1 1 0 48 24 24 0 1 1 0-48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLocust = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;